import { render, staticRenderFns } from "./boxType.vue?vue&type=template&id=3dc7f37d&scoped=true"
import script from "./boxType.vue?vue&type=script&lang=js"
export * from "./boxType.vue?vue&type=script&lang=js"
import style0 from "./boxType.vue?vue&type=style&index=0&id=3dc7f37d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7f37d",
  null
  
)

export default component.exports